<template>
    <modal size="lg" :height-max="true" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Contribution Basis</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Plan: </span>{{ plan.display_name }}</div>
                </div>
            </div>

            <p>Select the earning types that count toward this plan&rsquo;s contribution basis. Both employee contributions and the employer match are calculated on the total of the selected earnings.</p>

            <p class="text-muted">
                <i class="far fa-info-circle" aria-hidden="true"></i>
                With nothing selected, the basis falls back to all real earnings including tips, excluding imputed income.
            </p>

            <company-earning-type-selector
                v-if="earningTypesLoaded"
                :company-earning-types="companyEarningTypes"
                v-model="formData.company_earning_types"
            />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import CompanyEarningTypeSelector from '@/pages/client/Settings/components/CompanyEarningTypeSelector'

export default {
    props: ['client', 'plan', ],
    mixins: [FormMixin, ModalMixin],
    components: {CompanyEarningTypeSelector, },
    emits: ['close', 'updated', ],
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.plan.company_id)
        },
        companyEarningTypes() {
            if (!this.earningTypesLoaded) {return []}
            return this.allEarningTypes.filter(cet => cet.company_id == this.plan.company_id)
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            allEarningTypes: [],
            earningTypesLoaded: false,
        }
    },
    mounted() {
        this.getEarningTypes()
    },
    methods: {
        getEarningTypes() {
            // NB: ordering is owned by CompanyEarningTypeSelector (sort_priority, then
            // name), so there is deliberately no sort here.
            this.$api.get(`/clients/${this.client.id}/earning-types`).then(resp => {
                this.allEarningTypes = resp
                this.earningTypesLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        makeFormData() {
            const data = {
                company_earning_types: []
            }
            ;(this.plan.deferred_comp_plan_earning_types || []).forEach(rel => {
                data.company_earning_types.push(rel.company_earning_type.id)
            })
            return data
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/clients/${this.client.id}/settings/deferred-comp-plans/${this.plan.id}/earning-types`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated')
                this.$bus.showInfo(`Successfully updated contribution basis.`)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
